import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { APP_BASE_HREF, PlatformLocation } from "@angular/common";
import {
  HttpClient,
  HttpClientModule
} from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { NgxWebstorageModule } from 'ngx-webstorage';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import {
  ErrorComponent,
  MainComponent,
  NarrowNavigationComponent,
  NavbarComponent,
  NavigationComponent,
} from 'app/layouts';
import { LANGUAGES, SharedModule } from 'app/shared';
import { GlobalErrorHandler } from 'app/blocks/global-error-handler';
import { CoreModule } from 'app/core/core.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';



export function getBaseHref(platformLocation: PlatformLocation): string {
  return platformLocation.getBaseHrefFromDOM();
}

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatExpansionModule,
    MatProgressBarModule,
    MatSidenavModule,
    TranslateModule.forRoot({
      useDefaultLang: true,
      loader: {
        provide: TranslateLoader,
        useFactory: c => new TranslateHttpLoader(c, 'i18n/', `.json`),
        deps: [HttpClient],
      },
    }),
    NgxWebstorageModule.forRoot({ prefix: 'jhi', separator: '-' }),
    SharedModule.forRoot(),
    CoreModule,
    AppRoutingModule
  ],
  declarations: [
    AppComponent,
    MainComponent,
    NavbarComponent,
    NavigationComponent,
    NarrowNavigationComponent,
    ErrorComponent,
    NavigationComponent,
  ],
  providers: [
    {
      provide: APP_BASE_HREF,
      useFactory: getBaseHref,
      deps: [PlatformLocation]
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class ManagementPortalAppModule {
  constructor(translate: TranslateService) {
    let browserLang = translate.getBrowserLang();
    translate.use(LANGUAGES.includes(browserLang) ? browserLang : 'en');
  }
}
